export default "__VITE_ASSET__Bw88U4IB__"